(function(){
    'use strict';

    angular
    .module('app')
    .controller('FilesconfigController', FilesconfigController)
 
    FilesconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function FilesconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.scopeParent = "";
        vm.sizes = [];

        vm.cropChecked = "";
        vm.multigaleriaChecked = "";
        vm.maxItems = "";

        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

			
            j.references["multigaleriaChecked"] = vm.multigaleriaChecked;
            j.references["maxItems"] = vm.maxItems;
            j.references["cropChecked"] = vm.cropChecked;
            j.references["sizes"] = vm.sizes;

			////console.log(vm);
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
			//console.log(vm.scopeParent);
			//$("#json").val( angular.toJson(j) );
        }

        vm.borrarCrop = function(index){
            vm.sizes.splice(index,1);
            vm.update();
        }

        vm.cropCheck = function(){
			if(vm.cropChecked){
				$('#cropDiv').show();
			}else{
				$('#cropDiv').hide();
			}
			vm.update();
		}

        vm.multiGaleriaCheck = function(){
			if(vm.multigaleriaChecked){
				$('#multigaleriaDiv').show();
			}else{
				$('#multigaleriaDiv').hide();
			}
			vm.update();
		}

        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		vm.sizes = vm.json.references.sizes;
        	}
        	//console.log(vm.json);
        	vm.multiGaleriaCheck();
			vm.cropCheck();
			
        }
        vm.addCrop = function(){
        	if(typeof vm.sizes=='undefined'){
        		vm.sizes = [];
        	}
        	vm.sizes.push({"width":0,"height":0});
        	vm.update();
        }
        vm.borrarCrop = function(index){
        	vm.sizes.splice(index,1);
        	vm.update();
        }
    } 

})();